import React, { FC } from "react"

interface Props {
    value: string
    onChange: (fontStyle: string) => void
    prefix: string
}

export const FontStylePicker: FC<Props> = ({ value, onChange, prefix }) => {
    const italic = value === "italic"

    const toggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        onChange(italic ? "normal" : "italic")
    }

    return (
        <div className={`${prefix}__font-style`}>
            <button
                className={`${prefix}__button ${prefix}__button--italic ${italic ? `${prefix}__button--active` : ""}`}
                onMouseDown={toggle}
                aria-label="Italic"
                aria-pressed={italic}
                type="button"
            >
                I
            </button>
        </div>
    )
}
